var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.doctype)?_c(_vm.doctype,_vm._b({tag:"Component"},'Component',Object.assign({}, _vm.$data, {isFirstPage: _vm.isFirstPage}),false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }